module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md2": "",
      "pt-0": ""
    }
  }, [_c('v-select', {
    staticClass: "filter-select",
    attrs: {
      "items": _vm.subsidiaries,
      "item-text": "name",
      "item-value": "id",
      "hide-details": "",
      "label": "Sucursal",
      "single-line": "",
      "bottom": ""
    },
    on: {
      "change": _vm.loadBuildings
    },
    model: {
      value: (_vm.subsidiaryId),
      callback: function($$v) {
        _vm.subsidiaryId = $$v
      },
      expression: "subsidiaryId"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md2": "",
      "pt-0": ""
    }
  }, [_c('v-select', {
    staticClass: "filter-select",
    attrs: {
      "items": _vm.buildings,
      "disabled": _vm.buildings.length === 0,
      "item-text": "name",
      "item-value": "id",
      "hide-details": "",
      "label": "Edificio",
      "single-line": "",
      "bottom": ""
    },
    on: {
      "change": _vm.loadRooms
    },
    model: {
      value: (_vm.buildingId),
      callback: function($$v) {
        _vm.buildingId = $$v
      },
      expression: "buildingId"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": "",
      "mt-3": ""
    }
  }, [_c('div', {
    staticClass: "wrap-select-rooms text-xs-left"
  }, [_c('span', {
    staticClass: "little-subtitle-default"
  }, [_vm._v("Seleccione las habitaciones:")]), _vm._v(" "), _c('span', {
    staticClass: "subtitle-right"
  }, [_vm._v("5 habitaciones")]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "mt-3": ""
    }
  }, _vm._l((_vm.rows), function(row) {
    return _c('room-status', {
      key: row.id,
      attrs: {
        "clean-state": row.clean_state,
        "number": row.number,
        "code": row.code,
        "room": row,
        "labelFor": ("room-" + (row.number)),
        "roomId": row.id,
        "extra-state": row.state,
        "size": 'medium',
        "status-icon": row.icon
      },
      on: {
        "on-room-selected": _vm.updateRowsSelected
      }
    })
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "select-clean-type text-xs-left"
  }, [_c('span', {
    staticClass: "little-subtitle-default"
  }, [_vm._v("Tipo de limpieza:")]), _vm._v(" "), _c('div', {
    staticClass: "select-slots-housekeeping mt-2"
  }, [_c('v-select', {
    attrs: {
      "items": _vm.states,
      "item-text": "name",
      "item-value": "name",
      "chips": "",
      "max-height": "auto",
      "hide-details": ""
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(data) {
        return [_vm._v("\n\t\t\t\t\t\t" + _vm._s(data.item.name) + "\n\t\t\t\t\t\t"), _c('room-status', {
          attrs: {
            "clean-state": data.item.id,
            "number": data.item.number,
            "code": data.item.code,
            "room": data.item,
            "labelFor": ("room-" + (data.item.number)),
            "extra-state": data.item.state,
            "size": 'medium',
            "status-icon": data.item.icon
          }
        })]
      }
    }, {
      key: "item",
      fn: function(data) {
        return [
          [_c('v-list-tile-content', [_c('v-list-tile-title', {
            domProps: {
              "innerHTML": _vm._s(data.item.name)
            }
          })], 1), _vm._v(" "), _c('room-status', {
            attrs: {
              "clean-state": data.item.id,
              "number": data.item.number,
              "code": data.item.code,
              "room": data.item,
              "extra-state": data.item.state,
              "size": 'medium',
              "status-icon": data.item.icon
            }
          })]
        ]
      }
    }]),
    model: {
      value: (_vm.states.filter(function (state) { return state.id === Number(_vm.$route.params.stateId); })[0].name),
      callback: function($$v) {
        _vm.states.filter(function (state) { return state.id === Number(_vm.$route.params.stateId); })[0].name = $$v
      },
      expression: "states.filter(state => state.id === Number($route.params.stateId))[0].name"
    }
  })], 1)]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-left": ""
    }
  }, [_c('v-btn', {
    staticClass: "btn-add",
    on: {
      "click": function($event) {
        _vm.addToRowsSelected(_vm.roomsSelected)
      }
    }
  }, [_vm._v("\n\t\t\t\tAgregar\n\t\t\t")])], 1)], 1), _vm._v(" "), _c('v-divider', {
    staticClass: "divider-full"
  }), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('span', {
    staticClass: "little-subtitle-default"
  }, [_vm._v("Asigne a la mucama:")]), _vm._v(" "), _c('user-selector-list', {
    staticClass: "mt-2",
    attrs: {
      "users": _vm.users
    },
    on: {
      "on-change-selected": _vm.onUserSelected
    }
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md12": "",
      "text-xs-left": ""
    }
  }, [_c('v-btn', {
    staticClass: "btn-add",
    on: {
      "click": _vm.addUserSelected
    }
  }, [_vm._v("\n\t\t\t\tAgregar\n\t\t\t")])], 1)], 1), _vm._v(" "), _c('v-divider', {
    staticClass: "divider-full"
  }), _vm._v(" "), _c('v-layout', {
    staticClass: "full-layout-white",
    attrs: {
      "row": "",
      "wrap": "",
      "text-xs-left": ""
    }
  }, [_c('v-flex', {
    staticClass: "body-border-right",
    attrs: {
      "md6": "",
      "pr-3": "",
      "mb-3": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('span', {
    staticClass: "little-subtitle-default"
  }, [_vm._v("Habitaciones:")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "empty-container",
    attrs: {
      "xs12": ""
    }
  }, [(_vm.rowsSelected) ? _c('div', {
    staticClass: "mt-2"
  }, _vm._l((_vm.rowsSelected), function(row) {
    return _c('room-status', {
      key: row.id,
      attrs: {
        "clean-state": row.clean_state,
        "number": row.number,
        "room": _vm.room,
        "code": row.code,
        "isAdded": row.isAdded,
        "labelFor": ("room-" + (row.number)),
        "extra-state": row.state,
        "size": 'medium',
        "status-icon": row.icon,
        "roomId": row.id
      },
      on: {
        "on-room-removed": _vm.removeThisRow
      }
    })
  })) : _vm._e()])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('span', {
    staticClass: "little-subtitle-default"
  }, [_vm._v("Mucamas:")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(_vm.userAdded) ? _c('user-selector', {
    staticClass: "mt-2",
    attrs: {
      "user": _vm.userAdded
    },
    on: {
      "on-user-removed": _vm.userRemoved
    }
  }) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "md6": "",
      "pl-3": ""
    }
  }, [_c('span', {
    staticClass: "little-subtitle-default"
  }, [_vm._v("Tipo de limpieza:")]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.cleanTypes), function(type) {
    return _c('div', {
      key: type.id
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.cleanTypeSelected),
        expression: "cleanTypeSelected"
      }],
      staticClass: "input-clean-type",
      attrs: {
        "type": "radio",
        "hidden": "",
        "name": "cleanTypes",
        "id": type.id
      },
      domProps: {
        "value": type.id,
        "checked": _vm._q(_vm.cleanTypeSelected, type.id)
      },
      on: {
        "__c": function($event) {
          _vm.cleanTypeSelected = type.id
        }
      }
    }), _vm._v(" "), _c('label', {
      staticClass: "clean-type",
      attrs: {
        "for": type.id
      }
    }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(type.name) + "\n\t\t\t\t\t")])])
  })), _vm._v(" "), _c('span', {
    staticClass: "little-subtitle-default"
  }, [_vm._v("Comentario o sugerencia:")]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.comment),
      expression: "comment"
    }],
    staticClass: "mt-2 mb-3",
    attrs: {
      "name": "assign-comment",
      "cols": "80",
      "rows": "3"
    },
    domProps: {
      "value": (_vm.comment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.comment = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "text-xs-right": ""
    }
  }, [_c('v-btn', {
    staticClass: "btn-assign-tasks"
  }, [_vm._v("\n\t\t\t\tAsignar a tareas\n\t\t\t")])], 1)], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "timeout": _vm.timeout,
      "success": _vm.context === 'success',
      "info": _vm.context === 'info',
      "warning": _vm.context === 'warning',
      "error": _vm.context === 'error',
      "primary": _vm.context === 'primary',
      "secondary": _vm.context === 'secondary',
      "top": "",
      "right": ""
    },
    model: {
      value: (_vm.snackbar),
      callback: function($$v) {
        _vm.snackbar = $$v
      },
      expression: "snackbar"
    }
  }, [_vm._v("\n\t\t" + _vm._s(_vm.text) + "\n\t")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-21a5ee46","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/housekeeping/dashboard/DetailByState.vue
// module id = 1600
// module chunks = 63